module.exports = __webpack_public_path__ + "img/android-chrome-192x192.e90c2f55.png";